"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _EditableInputWithVariable = require("@insided/deprecated-control/ui-components/EditableInputWithVariable");

var VariableParser = /*#__PURE__*/function () {
  function VariableParser(value) {
    (0, _classCallCheck2.default)(this, VariableParser);
    (0, _defineProperty2.default)(this, "_result", void 0);
    this._result = value.replace(/&amp;/g, '&');
  }

  (0, _createClass2.default)(VariableParser, [{
    key: "toInputVariable",
    value: function toInputVariable() {
      var addSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this._result = this._result.replace(/{username}/g, addSpace ? _EditableInputWithVariable.UsernameVariableNode : _EditableInputWithVariable.UsernameVariableWithoutSpaceNode);
      return this;
    }
  }, {
    key: "toBracketVariable",
    value: function toBracketVariable() {
      this._result = this._result.replace(/<input-variable.+?>/g, '{').replace(/<\/input-variable+?>/g, '}');
      return this;
    }
  }, {
    key: "removeBreakTags",
    value: function removeBreakTags() {
      this._result = this._result.replace(/<br>/g, '');
      return this;
    }
  }, {
    key: "replaceBlankSpaces",
    value: function replaceBlankSpaces() {
      this._result = this._result.replace(/&nbsp;/g, ' ');
      return this;
    }
  }, {
    key: "result",
    value: function result() {
      return this._result;
    }
  }]);
  return VariableParser;
}();

exports.default = VariableParser;